const GET_DEV_STEP_EXTERNALS = "GET_DEV_STEP_EXTERNALS";
const GET_SINGLE_DEV_STEP_EXTERNAL = "GET_SINGLE_DEV_STEP_EXTERNAL";
const SET_ACTIVE_DEV_STEP_EXTERNAL_ID = "SET_ACTIVE_DEV_STEP_EXTERNAL_ID";
const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
const SET_ITEM_CODE = "SET_ITEM_CODE";
const SET_REQUEST_STATUS_FILTER = "SET_REQUEST_STATUS_FILTER";
const RESET_STATE = "RESET_STATE";

export { GET_DEV_STEP_EXTERNALS, GET_SINGLE_DEV_STEP_EXTERNAL, SET_ACTIVE_DEV_STEP_EXTERNAL_ID, SET_ACTIVE_PAGE, SET_ITEM_CODE, SET_REQUEST_STATUS_FILTER, RESET_STATE };
